"use client";

import { useRouter } from "next/navigation";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { browserCmw } from "@/lib/ky/browser";
import { setSession } from "@/lib/session";
import { routes } from "@/lib/routes";
import type { AccountType } from "cmw-client";

export interface SignInWithPasswordInput {
  email: string;
  password: string;
  accountType: AccountType;
}

const dashboardByAccountType: Record<AccountType, string> = {
  admin: routes.adminDashboard.url,
  practioner: routes.dashboard.url,
};

export function useSignInWithPassword(takeTurnstileToken: () => Promise<string>) {
  const router = useRouter();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email, password, accountType }: SignInWithPasswordInput) => {
      const credentials = { email, password };
      const turnstileToken = await takeTurnstileToken();
      const auth =
        accountType === "admin"
          ? await browserCmw.auth.signInAsStaff(credentials, turnstileToken)
          : await browserCmw.auth.signInAsPractioner(credentials, turnstileToken);

      await setSession(auth);

      return auth;
    },
    onSuccess: (_data, { accountType }) => {
      queryClient.clear();
      router.push(dashboardByAccountType[accountType]);
    },
  });
}
